module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// /home/travis/build/Pedro-vk/Bet-Token-wallet/node_modules/readable-stream/passthrough.js
// module id = rr9E
// module chunks = 0